import {takeEvery, put, all} from 'redux-saga/effects';
import {push} from 'react-router-redux';
import types from '../actions/types';
import {LOCATION_CHANGE} from 'react-router-redux';

// import {configValueEmpty} from '../utils/app-config';

function* openGameEdit(action) {
    yield put(push(`/app/games/${action.payload.id}`));
}

function onLocationChange() {
    // if (configValueEmpty('tag_manager_id')) {
    //     const dataLayer = window.dataLayer = window.dataLayer || [];
    //     dataLayer.push({'event': 'pageview', 'content-name': window.location.pathname});
    // }
}

function* openGamesList() {
    yield put(push('/app/games/'));
}


export default function* flowSagas() {
    yield all([
        takeEvery(types.OPEN_GAME_EDIT, openGameEdit),
        takeEvery(types.OPEN_GAMES_LIST, openGamesList),

        takeEvery(LOCATION_CHANGE, onLocationChange)
    ]);
}



// WEBPACK FOOTER //
// ./src/js/sagas/flow-sagas.js